@if(form && question) {
  <div [ngClass]="{'form-check': question.type === 'checkbox'}">
    @if (question.type !== 'checkbox' && question.label) {
      <label [ngClass]="{'req-star': question.required, 'form-check-label': question.type === 'checkbox'}" class="fw-bold"
             [for]="question.key">
        {{ question.label }}
      </label>
    }

    <ng-content></ng-content>

    @if (question.type === 'checkbox' && question.label) {
      <label [ngClass]="{'req-star': question.required, 'form-check-label': question.type === 'checkbox'}"
             [for]="question.key">
        {{ question.label }}
      </label>
    }

    @if (question.warn) {
      <div class="text-light-grey text-warning">
        <fa-icon icon="exclamation-triangle"></fa-icon>
        &nbsp;{{ question.warn }}
      </div>
    }

    @if (question.info) {
      <div class="text-light-grey text-info">
        <fa-icon icon="info-circle"></fa-icon>
        &nbsp;{{ question.info }}
      </div>
    }

    @if (!isValid && question.type !== 'checkbox') {
      <app-fields-errors [errors]="form.controls[question.key]?.errors"></app-fields-errors>
    }
  </div>
}
